export const TITLE = 'TermWebPublish';
export const APP_NAME = 'TermWebPublish';
export const COPYRIGHT = 'Copyright © 2023-2026 Interverbum Technology AB';
